import React from "react"

import { StaticQuery, graphql } from "gatsby"
import { Link } from "gatsby"

const query = graphql`
  query {
    allSanityArticle {
      edges {
        node {
          title
          description
          slug {
            current
          }
        }
      }
    }
  }
`

const ArticleList = () => (
  <StaticQuery
    query={query}
    render={data => (
      <ul>
        {data.allSanityArticle.edges.map(article => (
          <li key={article.node.id}>
            <Link to={`/articles/${article.node.slug.current}`}>
              {article.node.title}
            </Link>
          </li>
        ))}
      </ul>
    )}
  />
)

export default ArticleList
